export default __webpack_public_path__ + "static/media/user-round.27fe79b1.svg";